"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * IE11-safe version of getCanonicalLocales since it's ES2016
 * @param locales locales
 */
function getCanonicalLocales(locales) {
    // IE11
    var getCanonicalLocales = Intl.getCanonicalLocales;
    if (typeof getCanonicalLocales === 'function') {
        return getCanonicalLocales(locales);
    }
    return Intl.NumberFormat.supportedLocalesOf(locales || '');
}
exports.getCanonicalLocales = getCanonicalLocales;



/*****************
 ** WEBPACK FOOTER
 ** ../~/@formatjs/intl-utils/dist/get-canonical-locales.js
 ** module id = 879
 ** module chunks = 0
 **/